export enum SidebarEnum {
  QUESTIONNAIRE = "questionnaire",
  DOCUMENTS = "documents",
  MAPPINGS = "mappings",
}

export enum RoutesEnum {
  // generic
  ALL = "*",
  DEFAULT = "",
  ERROR = "error",
  BASIC = "/",
  LANDING = "landing",

  QUESTIONNAIRE = "questionnaire",
  DOCUMENTS = "documents",
  MAPPINGS = "mappings",

  CREATE_NEW = 'create_new',
  DETAILS = "details",
  CATEGORIES = "categories",
}

export enum SessionKeys {
  DOCUMENT_DATA = 'documentData'
}

export interface ISidebarModel {
  link: SidebarEnum;
  linkName: string | SidebarEnum;
  url: string;
  icon: any;
  activeIcon: any;
}
